// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "webrtc-adapter";

import { createApp } from 'vue'
import Notifications from '@kyvg/vue3-notification'
import App from './App'

import router from './router/router.js'
import {
    store
} from './store.js';
import {
    notifyMixin,
    ERROR_TYPE
} from './utils.js';


/*
let inBarCode = false;
let barcode = "";

document.addEventListener('keypress', function(e) {
    // handle scanning manually, prevent all scanning-related events
    if (e.key === "!" ||
        e.key === "¤" ||
        e.key.toLowerCase() === "enter" ||
        inBarCode) {
            e.preventDefault();
    }

    // prefix
    if (e.key === "!" || e.key === "¤") {
        inBarCode = true;
        return;
    }

    // suffix
    if (e.key.toLowerCase() === "enter") {
        inBarCode = false;
        alert("Scanned barcode: " + barcode)
        barcode = "";
        return;
    }

    if (inBarCode) {
        barcode += String.fromCharCode(e.keyCode)
    }
});
*/

// this logic is very convoluted because
// barcode scanners connected to a computer,
// and barcode scanning from the zebra phone
// work slightly differently
let inBarCode = false;
let barcode = "";
let lastWasModifier = false;
let lastWasShift = false;
let lastWasExclam = false;


document.addEventListener('keypress', function(e) {
    console.log("KEY PRESS: " + e.key)

    if (e.key === "Shift" && (!lastWasExclam)) {
        lastWasShift = true;
        lastWasExclam = false;
        e.preventDefault()
        return;
    }

    if (e.key === "!" || (lastWasShift && e.key == "4") || e.key === "¤") {
        document.activeElement.blur();
        e.preventDefault()
        inBarCode = true;
        if (!lastWasShift) {
            lastWasModifier = true;
        }
        lastWasShift = false;

        if (e.key !== "!") {
            lastWasExclam = false;
        } else if (e.key === "!") {
            lastWasExclam = true;
        }
        return;
    }

    if (e.keyCode === 13 && inBarCode) {
        store.dispatch('scanHandler', barcode);
        // reset
        barcode = "";
        inBarCode = false;
        lastWasShift = false;
        lastWasExclam = false;
        return;
    }

    if (inBarCode) {
        // skip prefix character
        //if (lastWasModifier) {
        //    lastWasModifier = false;
        //    lastWasShift = false;
        //    lastWasExclam = false;
        //    return;
        //}

        barcode += String.fromCharCode(e.keyCode)
    }

    lastWasExclam = false;
    lastWasShift = false;
    console.log("Received keyboard input, key: " + e.key)
});

/* eslint-disable no-new */
// Create Vue 3 app instance
const app = createApp(App);

// Use Notifications
app.use(Notifications);

// Global mixin for error handling
app.mixin({
    data() { return ERROR_TYPE },
    methods: {
        notifyMixin
    }
});

// Use router and store
app.use(router);
app.use(store);

router.beforeEach((to, from, next) => {
    // Hver gang du trykker deg inn på en lenke,
    // skal den sjekke at du faktisk enda er pålogget.
    store.commit('resetLoaders');
    //if (store.getters.isUserAuthenticated) {
        // TODO: this didn't work anyway,
        // isUserAuthenticated was always false...
        /*
        console.log("user is auth'd");
        store.commit('refreshAuthToken')
            .then(() => next())
            .catch(e => {
                console.log("exception committing refreshAuthToken");
                store.commit("logout");
                router.push({
                    name: 'Default',
                    params: {
                        errorMsg: e
                    }
                });
            });
            */
    //} else {
        next();
    //}
});

// Mount the app
app.mount('#app');